<div class="profile-container">
  <div class="">
    <div class="profile-content">
      <!-- <div class="personal-details">
       
        <h4 class="personal-details-title">Un Verified Customer List</h4>
        <table class="table table-striped">
          <thead>
            <tr>
              <th scope="col">Customer Id</th>
              <th scope="col">Name</th>
              <th scope="col">Mobile</th>
              <th scope="col">Email Id</th>
              <th scope="col">Status</th>
              <th scope="col">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let x of ECdata | paginate : {
              itemsPerPage: tableSize,
              currentPage: page,
              totalItems: count
              };let i = index">
              <td scope="col">{{x.customerId}}</td>
              <td scope="col">{{x.name}}</td>
              <td scope="col">{{x.mobileNo}}</td>
              <td scope="col">{{x.email}}</td>
              <td scope="col">{{x.latestStatus}}</td>
              <td>
                <i class="bi bi-eye-fill" (click)="getECbyId(x.existingCustomerInfoId)" data-toggle="modal" data-target="#exampleModalCenter"></i>
                <i (click)="getECbyId(x.existingCustomerInfoId)" data-toggle="modal" data-target="#editModalCenter" class="bi bi-pencil-square"></i>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="pagination-block" *ngIf="ECdata.length != 0">
          <pagination-controls
            previousLabel="Prev"
            nextLabel="Next"
            (pageChange)="onTableDataChange($event)"
          >
          </pagination-controls>
        </div>
      </div> -->


      <div class="personal-details">
          
        <div class="header-block">
            <div class="header-title">
                <p>Un Verified Customer List</p>
            </div>
            <div class="add-block">
                <div class="search">
                    <form autocomplete="off" >
                        <input type="text" placeholder="search">
                    </form>
                    <i class="bi bi-search" ></i>
                </div>
                <button data-toggle="modal" data-target="#exampleModal"><i class="bi bi-plus-lg"></i> Add</button>
            </div>
        </div>

        <table class="table table-striped">
            <thead>
                <tr>
                <th style="width: 10%;">Cust Id</th>
                <th style="width: 15%;">Name</th>
                <th style="width: 12%;">Mobile</th>
                <th style="width: 18%;">Email Id</th>
                <th style="width: 15%;">Created Date</th>
                <th style="width: 15%;">Status</th>
                <th style="width: 15%;text-align: center;padding: 0;" class="">Action</th>
                </tr>
            </thead>
        </table>
        <div *ngIf="!isLoading">
            <div class="data-view" *ngFor="let ec of ECdata | paginate : {
                  itemsPerPage: tableSize,
                  currentPage: page,
                  totalItems: count
                }  ;let i = index">

                <p style="width: 10%;">{{ec.customerId}}</p>
                <p style="width: 15%;">{{ec.name}}</p>
                <p style="width: 12%;">{{ec.mobileNo}}</p>
                <p style="width: 18%;">{{ec.email}}</p>
                <p style="width: 15%;">{{ec.createdDate | date}}</p>
                <p style="width: 15%;">{{ec.latestStatus}}</p>
            
                <p class="action-buttons" style="width: 15%;padding-left: 25px;">
                  <i class="bi bi-eye-fill" (click)="getECbyId(ec.existingCustomerInfoId)" data-toggle="modal" data-target="#exampleModalCenter"></i>
                  <i (click)="getECbyId(ec.existingCustomerInfoId)" data-toggle="modal" data-target="#editModalCenter" class="bi bi-pencil-square"></i>
                </p>
            </div>
        </div>


        <div class="loader" *ngIf="isLoading">
            <div class="spinner"></div>
        </div>

        <div class="loader"  *ngIf="!isLoading && ECdata.length == 0">
            <div class="no-data">
                <img src="assets/no-data-6.png" alt="">
                <p>no data found</p>
            </div>
            
        </div>

        <div class="paginator">
            <p-paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="tableSize" [totalRecords]="count"
            [showFirstLastIcon]="false" [showCurrentPageReport]="true" currentPageReportTemplate="{first} - {last} of {totalRecords}">
            </p-paginator>
        </div>


    </div>
    </div>
  </div>
</div>

<div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="close-modal">
        <i class="bi bi-x-lg" data-dismiss="modal"></i>
      </div>
      <div class="prospect-block" *ngFor="let data of data">
        <div class="prospect-content">
          <div class="application-details">
            <p class="application-title">Personal Details: <i (click)="editEC()" class="bi bi-pencil-square"></i></p>
            <div class="row application-form-details">
              <div class="col-md-4 col-lg-4 application-form">
                <label for="">Mobile</label>
                <p *ngIf="data.mobileNo != ''">{{data.mobileNo}}</p>
                <p *ngIf="data.mobileNo == ''">--</p>
              </div>
              <div class="col-md-4 col-lg-4 application-form">
                <label for="">Name</label>
                <p *ngIf="data.name != ''">{{data.name}}</p>
                <p *ngIf="data.name == ''">--</p>
              </div>
              <div class="col-md-4 col-lg-4 application-form">
                <label for="">Email</label>
                <p *ngIf="data.email != ''">{{data.email}}</p>
                <p *ngIf="data.email == ''">--</p>
              </div>
              <div class="col-md-4 col-lg-4 application-form">
                <label for="">Installation Address</label>
                <p *ngIf="data.installationAddress != ''">{{data.installationAddress}}</p>
                <p *ngIf="data.installationAddress == ''">--</p>
              </div>
          
              <!-- <div class="col-md-4 col-lg-4 application-form">
                <label for="">Alternate Mobile</label>
                <p *ngIf="data.altMobileNo != ''">{{data.altMobileNo}}</p>
                <p *ngIf="data.altMobileNo == ''">--</p>
              </div> -->
             
              <!-- <div class="col-md-4 col-lg-4 application-form">
                <label for="">Alternate Email</label>
                <p *ngIf="data.altEmail != ''">{{data.altEmail}}</p>
                <p *ngIf="data.altEmail == ''">--</p>
              </div> -->
          

              <div class="col-md-4 col-lg-4 application-form">
                <label for="">Application Form For</label>
                <p *ngIf="data.applicationFormFor != ''">{{data.applicationFormFor}}</p>
                <p *ngIf="data.applicationFormFor == ''">--</p>
              </div>

              <div class="col-md-4 col-lg-4 application-form">
                <label for="">Status</label>
                <p *ngIf="data.latestStatus != ''">{{data.latestStatus}}</p>
                <p *ngIf="data.latestStatus == ''">--</p>
              </div>

              <div class="col-md-4 col-lg-4 application-form">
                <label for="">customer Id</label>
                <p *ngIf="data.customerId != ''">{{data.customerId}}</p>
                <p *ngIf="data.customerId == ''">--</p>
              </div>
            </div>
          </div>

          <div class="big-image" *ngIf="imageUrl != ''">
            <div class="image">
              <div class="close-x">
                <i class="bi bi-x-lg" (click)="closeImage()"></i>
              </div>
              <img src="{{imageUrl}}" alt="">
            </div>
          </div>

          <div class="row">
            <div class="identity-proof-details col-md-3 col-lg-3">
              <p class="identity-proof-title">Building Proof:</p>
              <div class=" identity-proof-form-details">
                <div class=" identity-proof-form">
                  <div class="proof-images">
                    <div class="image">
                      <img src="{{data.buildingUrl}}" (click)="imageUrlSelect(data.buildingUrl)" alt="">
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="identity-proof-details col-md-3 col-lg-3">
              <p class="identity-proof-title">Identity Proof:</p>
              <div class="row identity-proof-form-details">
                <div class=" identity-proof-form">
                  <div class="proof-images">
                    <div class="image">
                      <img src="{{data.idProofUrl}}" (click)="imageUrlSelect(data.idProofUrl)" alt="">
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="identity-proof-details col-md-3 col-lg-3">
              <p class="identity-proof-title">Photo Proof:</p>
              <div class="row identity-proof-form-details">
                <div class=" identity-proof-form">
                  <div class="proof-images">
                    <div class="image">
                      <img src="{{data.photoUrl}}" (click)="imageUrlSelect(data.photoUrl)" alt="">
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="identity-proof-details col-md-3 col-lg-3">
              <p class="identity-proof-title">Address Proof:</p>
              <div class="row identity-proof-form-details">
                <div class=" identity-proof-form">
                  <div class="proof-images">
                    <div class="image">
                      <img src="{{data.addressProofUrl}}" (click)="imageUrlSelect(data.addressProofUrl)" alt="">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
         

          <div class="applicant-details" *ngFor="let list of data.deviceInfoList">
            <p class="applicant-title">Device Details:</p>
            <div class="row applicant-form-details">
              <div class="col-md-4 col-lg-4 applicant-form">
                <label for="">Device Id</label>
                <p *ngIf="list.deviceId != ''">{{list.deviceId}}</p>
                <p *ngIf="list.deviceId == ''">--</p>
              </div>
              <div class="col-md-4 col-lg-4 applicant-form">
                <label for="">Device Type</label>
                <p *ngIf="list.deviceType != ''">{{list.deviceType}}</p>
                <p *ngIf="list.deviceType == ''">--</p>
              </div>
              <div class="col-md-4 col-lg-4 applicant-form">
                <label for="">Device Info</label>
                <p *ngIf="list.deviceInfo != ''">{{list.deviceInfo}}</p>
                <p *ngIf="list.deviceInfo == ''">--</p>
              </div>
            
              <div class="col-md-4 col-lg-4 applicant-form devive-proof-form">
                <label for="">Device Photo</label>
                <div class="proof-images" *ngIf="list.devicePhotoUrl != ''">
                  <div class="image">
                    <img src="{{list.devicePhotoUrl}}" (click)="imageUrlSelect(list.devicePhotoUrl)" alt="">
                  </div>
                </div>
                <p *ngIf="list.devicePhotoUrl == ''">--</p>

              </div>
            </div>
          </div>

        </div>
        <div class="modal-footer">
          <button class="btn btn-danger" (click)="rejectEC()">Reject</button>
          <button class="btn btn-success" (click)="approveEC()">Approve</button>
          <button type="button" id="closeModalButton" class="btn btn-secondary" data-dismiss="modal" class="btn btn-secondary">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="editModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="close-modal">
        <i class="bi bi-x-lg" data-dismiss="modal"></i>
      </div>
      <div class="prospect-block" *ngFor="let data of data">
        <div class="prospect-content">
          <div class="application-details">
            <p class="application-title">Personal Details:</p>
            <div class="row application-form-details" [formGroup]="editForm">
              <div class="col-md-6 col-lg-6 application-form">
                <label for="">customer Id</label>
                <!-- <p>{{data.customerId}}</p> -->
                <input type="text" formControlName="customerId" class="form-control">
              </div>
              <div class="col-md-6 col-lg-6 application-form">
                <label for="">Name</label>
                <!-- <p *ngIf="data.name != ''">{{data.name}}</p>
                <p *ngIf="data.name == ''">--</p> -->
                <input type="text" formControlName="name" class="form-control">

              </div>
              <div class="col-md-6 col-lg-6 application-form">
                <label for="">Email</label>
                <!-- <p *ngIf="data.email != ''">{{data.email}}</p>
                <p *ngIf="data.email == ''">--</p> -->
                <input type="text" formControlName="email" class="form-control">

              </div>
              <div class="col-md-6 col-lg-6 application-form">
                <label for="">Installation Address</label>
                <!-- <p *ngIf="data.installationAddress != ''">{{data.installationAddress}}</p>
                <p *ngIf="data.installationAddress == ''">--</p> -->
                <input type="text" formControlName="installationAddress" class="form-control">

              </div>
              <div class="col-md-6 col-lg-6 application-form">
                <label for="">Mobile</label>
                <p>{{data.mobileNo}}</p>
              </div>
              <!-- <div class="col-md-4 col-lg-4 application-form">
                <label for="">Alternate Mobile</label>
                <p *ngIf="data.altMobileNo != ''">{{data.altMobileNo}}</p>
                <p *ngIf="data.altMobileNo == ''">--</p>
              </div> -->
             
              <!-- <div class="col-md-4 col-lg-4 application-form">
                <label for="">Alternate Email</label>
                <p *ngIf="data.altEmail != ''">{{data.altEmail}}</p>
                <p *ngIf="data.altEmail == ''">--</p>
              </div> -->
          

              <div class="col-md-4 col-lg-4 application-form">
                <label for="">Application Form For</label>
                <p *ngIf="data.applicationFormFor != ''">{{data.applicationFormFor}}</p>
                <p *ngIf="data.applicationFormFor == ''">--</p>
              </div>

              <div class="col-md-4 col-lg-4 application-form">
                <label for="">Status</label>
                <p *ngIf="data.latestStatus != ''">{{data.latestStatus}}</p>
                <p *ngIf="data.latestStatus == ''">--</p>
              </div>
            </div>
          </div>

          <div class="big-image" *ngIf="imageUrl != ''">
            <div class="image">
              <div class="close-x">
                <i class="bi bi-x-lg" (click)="closeImage()"></i>
              </div>
              <img src="{{imageUrl}}" alt="">
            </div>
          </div>

          <div class="row">
            <div class="identity-proof-details col-md-3 col-lg-3">
              <p class="identity-proof-title">Building Proof:</p>
              <div class=" identity-proof-form-details">
                <div class=" identity-proof-form">
                  <div class="proof-images">
                    <div class="image">
                      <img src="{{data.buildingUrl}}" (click)="imageUrlSelect(data.buildingUrl)" alt="">
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="identity-proof-details col-md-3 col-lg-3">
              <p class="identity-proof-title">Identity Proof:</p>
              <div class="row identity-proof-form-details">
                <div class=" identity-proof-form">
                  <div class="proof-images">
                    <div class="image">
                      <img src="{{data.idProofUrl}}" (click)="imageUrlSelect(data.idProofUrl)" alt="">
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="identity-proof-details col-md-3 col-lg-3">
              <p class="identity-proof-title">Photo Proof:</p>
              <div class="row identity-proof-form-details">
                <div class=" identity-proof-form">
                  <div class="proof-images">
                    <div class="image">
                      <img src="{{data.photoUrl}}" (click)="imageUrlSelect(data.photoUrl)" alt="">
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="identity-proof-details col-md-3 col-lg-3">
              <p class="identity-proof-title">Address Proof:</p>
              <div class="row identity-proof-form-details">
                <div class=" identity-proof-form">
                  <div class="proof-images">
                    <div class="image">
                      <img src="{{data.addressProofUrl}}" (click)="imageUrlSelect(data.addressProofUrl)" alt="">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
         

          <div class="applicant-details" *ngFor="let list of data.deviceInfoList">
            <p class="applicant-title">Device Details:</p>
            <div class="row applicant-form-details">
              <div class="col-md-4 col-lg-4 applicant-form">
                <label for="">Device Id</label>
                <p *ngIf="list.deviceId != ''">{{list.deviceId}}</p>
                <p *ngIf="list.deviceId == ''">--</p>
              </div>
              <div class="col-md-4 col-lg-4 applicant-form">
                <label for="">Device Type</label>
                <p *ngIf="list.deviceType != ''">{{list.deviceType}}</p>
                <p *ngIf="list.deviceType == ''">--</p>
              </div>
              <div class="col-md-4 col-lg-4 applicant-form">
                <label for="">Device Info</label>
                <p *ngIf="list.deviceInfo != ''">{{list.deviceInfo}}</p>
                <p *ngIf="list.deviceInfo == ''">--</p>
              </div>
            
              <div class="col-md-4 col-lg-4 applicant-form devive-proof-form">
                <label for="">Device Photo</label>
                <div class="proof-images" *ngIf="list.devicePhotoUrl != ''">
                  <div class="image">
                    <img src="{{list.devicePhotoUrl}}" (click)="imageUrlSelect(list.devicePhotoUrl)" alt="">
                  </div>
                </div>
                <p *ngIf="list.devicePhotoUrl == ''">--</p>

              </div>
            </div>
          </div>

        </div>
        <div class="modal-footer">
          <button class="btn btn-success" (click)="customerRegistration()">Update</button>
          <button type="button" id="closeEditButton" data-dismiss="modal" class="btn btn-secondary">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</div>